import request from "request-promise-native";
import * as sentry from "@sentry/vue";
import { datadogRum } from "@datadog/browser-rum";

const root = process.env.VUE_APP_CONTENT_ROOT;
var defaultBrand;
var defaultLaw;

export function setDefaultBrand(brand) {
  defaultBrand = brand;
}

export function setDefaultLaw(law) {
  defaultLaw = law;
}

// returns an async function that resolves to the requested content (an HTML
// string)
export async function resolveContent(key, law, brand) {
  if (brand === undefined) {
    brand = defaultBrand;
  }

  if (law === undefined) {
    law = defaultLaw;
  }

  try {
    return await request(`${root}/${brand}/${law}/${key}.html`);
  } catch {
    try {
      return await request(`${root}/base/${key}.html`);
    } catch (error) {
      sentry.captureMessage(`${error}`, { level: "error", extra: { stack: error.stack } });
      datadogRum.addAction("DataCompliance.ResolveContent.Error", { error: `${error}`, stack: error.stack });
      return Promise.resolve(
        "A network error has occurred; please reload the page and try again."
      );
    }
  }
}
